// extracted by mini-css-extract-plugin
module.exports = {"container":"_11Srzq4Pa4cNIoLqteApg0","logo-spin":"hGlCPnPAF2rGNRMgeAOoV"};